import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import loadingIcon from '../../images/loadingicon.gif';

const AnimatedLoader = (props) => (
  <Div className={props.className}>
    <img src={loadingIcon} alt="Loading" width="80" height="80" />
  </Div>
);

const Div = styled.div`
  background-color: #fff;
  z-index: 1000;
`;

AnimatedLoader.propTypes = {
  className: PropTypes.string,
};

export default AnimatedLoader;



// WEBPACK FOOTER //
// ./app/components/AnimatedLoader/index.js